import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-parent-category',
  templateUrl: './parent-category.component.html',
  styleUrls: ['./parent-category.component.scss']
})
export class ParentCategoryComponent implements OnInit {

  @Input() category: any;
  @Input() categorySelection: any[];
  @Output() checkCategory = new EventEmitter<unknown>();
  constructor() { }

  ngOnInit(): void {
  }

  protected readonly onchange = onchange;
  isCollapsed: boolean = true;

  updateParent() {
    this.checkCategory.emit();
  }
}
